import { APP_SETTINGS } from "../../shared/app_settings";
import { CHANNELS } from "../../shared/channels";
import { NoteEntry } from "../../shared/types";
import { call } from "../bridge";
import { byId } from "../dom";
import { debounce } from "../utils";

// the always visible scratchpad at the top of notes, saved as its own note file

const input = () => byId<HTMLTextAreaElement>("scratchpad-body");

const save = debounce(() => {
  call(CHANNELS.notesSave, APP_SETTINGS.scratchpadNoteName, input().value);
}, APP_SETTINGS.noteAutosaveMs);

export function fillScratchpad(notes: NoteEntry[]): void {
  // never overwrite what fractal is typing right now
  if (document.activeElement === input()) return;
  input().value = notes.find((note) => note.name === APP_SETTINGS.scratchpadNoteName)?.content ?? "";
}

export function setupScratchpad(): void {
  input().addEventListener("input", save);
}
